import script from "./PedalSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PedalSelection.vue?vue&type=script&setup=true&lang=ts"

import "./PedalSelection.vue?vue&type=style&index=0&id=4aeb8b36&lang=scss"

const __exports__ = script;

export default __exports__